import React from 'react';
import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import * as ActionTypes from '../../constants/ActionTypes';
import { merge, set as setPath } from 'lodash';

const initialState = {
    primary: {
        colors: [
            { color: '#E50000', label: 'first' },
            { color: '#23826F', label: 'second' },
            { color: '#4A5767', label: 'third' },
            { color: '#FF8D2E', label: 'fourth' },
            { color: '#FFC694', label: 'fifth' },
            { color: '#3399CC', label: 'sixth' },
            { color: '#79CAF2', label: 'seventh' },
            { color: '#5FE9EA', label: 'eighth' },
            { color: '#099C9D', label: 'ninth' },
            { color: '#B0EA3B', label: 'tenth' },
            { color: '#729135', label: 'eleventh' },
            { color: '#000000', label: 'twelfth' }
        ],
        selected: 0
    },
    background: {
        colors: [
            { color: '#222222', label: 'Primary Background' },
            { color: '#A1A1A1', label: 'Secondary Background' },
            { color: '#E4E4E4', label: 'Tertiary Background' },
            { color: '#FFFFFF', label: 'Quaternary Background' }
        ],
        selected: 0
    },
    messages: {
        colors: [
            { color: '#AC0000', label: 'Error' },
            { color: '#CD8511', label: 'Warning' },
            { color: '#75A01F', label: 'Success' },
            { color: '#4A5767', label: 'Informational' }
        ],
        selected: 0
    }
};

const colorsReducer = handleActions(
    {
        [ActionTypes.THEME_COLORS_SET_COLOR]: (state, action) => {
            let newKeys = {};
            newKeys[action.target.panel] = {
                colors: [
                    ...state[action.target.panel].colors.slice(0, action.target.idx),
                    action.value,
                    ...state[action.target.panel].colors.slice(action.target.idx + 1)
                ]
            };
            return update(state, { $merge: newKeys });
        },
        [ActionTypes.MESSAGE_COLOR]: (state, action) => {
            let obj = {
                message: {
                    ...state.message
                }
            };
            obj['message'][action.messageType] = { ...state['message'][action.messageType], color: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.BACKGROUND_COLOR]: (state, action) => {
            let obj = {
                background: {
                    ...state.background
                }
            };
            obj['background'] = { ...state['background'], [action.messageType]: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_MODIFY_KEY]: (state, action) => {
            let pathCheck = action.path.split('.');
            if (pathCheck[0] === 'colors') {
                pathCheck.shift();
                return merge({}, state, setPath({}, pathCheck, action.value));
            } else {
                return state;
            }
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('message')) {
                return {
                    ...state,
                    message: action.theme.message,
                    background: action.theme.background,
                    border: action.theme.border,
                    primary: action.theme.palette.primary
                };
            } else {
                return state;
            }
        }
    },
    initialState
);

export default colorsReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/colors.js